<template>
  <div class="index">
    <el-form inline :rules="rules" ref="ruleForm" :model="formInline" class="demo-form-inline">
      <el-form-item label="小区/期" prop="xqName">
        <el-select v-model="formInline.xqName" filterable placeholder="请选择小区/期">
          <el-option :label="item" :value="item" v-for="(item, index) in xqName" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出入通道">
        <el-select v-model="formInline.serialNO" placeholder="出入通道">
          <el-option :label="item.ioName" :value="item.serialNO" v-for="(item, index) in io" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车牌号码">
        <el-input clearable v-model="formInline.carNum" placeholder="车牌号码"></el-input>
      </el-form-item>
      <el-form-item label="入场时间">
        <el-date-picker
          v-model="formInline.startTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="出场时间">
        <el-date-picker
          v-model="formInline.endTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="进场状态" prop="inType">
        <el-select clearable v-model="formInline.inType" filterable placeholder="请选择进场状态">
          <el-option :label="item.typeStr" :value="item.typeVal" v-for="(item, index) in gateInStatus" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item clearable label="出场状态" prop="outType">
        <el-select v-model="formInline.outType" filterable placeholder="请选择出场状态">
          <el-option :label="item.typeStr" :value="item.typeVal" v-for="(item, index) in gateOutStatus" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车辆类型" prop="carType">
        <el-select clearable v-model="formInline.carType" filterable placeholder="请选择车辆类型">
          <el-option :label="item.typeStr" :value="item.typeVal" v-for="(item, index) in types" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="查询收费纪录" prop="isPay">
        <el-switch
          v-model="formInline.isPay">
        </el-switch>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="money" v-if="formInline.isPay">合计实收金额：{{totalPayAct}}元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;合计应收金额：{{totalPay}}元</div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%">
      <el-table-column
        label="序号"
        width="50">
        <template slot-scope="scope">
          {{ scope.$index + pageSize * (pageNum - 1) }}
        </template>
      </el-table-column>
      <el-table-column
        width="100"
        prop="carNumber"
        label="车牌号">
      </el-table-column>
      <el-table-column
        prop="xqName"
        min-width="150"
        label="停车场">
      </el-table-column>
      <el-table-column
        prop="carTypeStr"
        label="车辆类型">
      </el-table-column>
      <el-table-column
        prop="inName"
        label="入口">
      </el-table-column>
      <el-table-column
        prop="inTimeStr"
        width="135"
        label="入场时间">
      </el-table-column>
      <el-table-column
        prop="outName"
        label="出口">
      </el-table-column>
      <el-table-column
        prop="outTimeStr"
        width="135"
        label="出场时间">
      </el-table-column>
      <el-table-column
        prop="stayTime"
        label="停留时间">
      </el-table-column>
      <el-table-column
        prop="payAble"
        label="应收金额">
      </el-table-column>
      <el-table-column
        prop="payActually"
        label="实收金额">
      </el-table-column>
      <el-table-column
        prop="inStatusStr"
        label="进场状态">
      </el-table-column>
      <el-table-column
        prop="outStatusStr"
        label="出场状态">
      </el-table-column>
      <el-table-column
        prop="freeReason"
        width="110"
        label="备注">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.freeReason" placement="top" v-if="scope.row.freeReason">
            <el-button type="text" class="b-remark">{{scope.row.freeReason}}</el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        width="200"
        label="查看图片">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="showImg(scope.row.comeInPhoto)">入场照片</el-button>
          <el-button
            size="mini"
            @click="showImg(scope.row.comeOutPhoto)">出场照片</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page="pageNum"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total"
        @current-change="change">
      </el-pagination>
    </div>
    <div class="showImg" v-if="imgSrc !== ''">
      <div class="main">
        <img :src="imgSrc" alt="">
        <div class="close" @click.self="imgSrc = ''">+</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import { ApiBack } from '../api'
export default {
  data () {
    return {
      xqName: [],
      reslut: [],
      formInline: {
        xqName: '',
        serialNO: '',
        carNum: '',
        startTime: null,
        endTime: null,
        inType: '',
        outType: '',
        carType: '',
        isPay: false
      },
      rules: {
        xqName: [
          { required: true, message: '请选择小区/期', trigger: 'change' }
        ]
      },
      gateTypes: [],
      gateInStatus: [],
      gateOutStatus: [],
      types: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      imgSrc: '',
      first: false,
      totalPay: 0,
      totalPayAct: 0
    }
  },
  computed: {
    io () {
      if (this.formInline.xqName) {
        return this.reslut[this.formInline.xqName]
      } else {
        return []
      }
    }
  },
  activated () {
    this.xqNames()
    this.carTypes()
    this.openGateTypes()
    this.openGateInStatus()
    this.openGateOutStatus()
    this.ioInfo()
  },
  methods: {
    xqNames () {
      const t = this
      t.$store.dispatch('getUser')
      const back = new ApiBack(t.$store.state.user.message)
      Loading.service()
      back.xqNames().then((res) => {
        if (res.data.code === 0) {
          t.xqName = res.data.data
          if (t.first) {
            t.onSubmit('ruleForm')
          } else {
            if (t.xqName.length > 0) {
              t.formInline.xqName = t.xqName[0]
            }
          }
        } else {
          t.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          })
        }
        Loading.service().close()
      })
    },
    ioInfo () {
      const t = this
      t.$store.dispatch('getUser')
      const back = new ApiBack(t.$store.state.user.message)
      Loading.service()
      back.ioInfo().then((res) => {
        if (res.data.code === 0) {
          t.reslut = res.data.data
          t.xqName = Object.keys(res.data.data)
          if (t.first) {
            t.onSubmit('ruleForm')
          } else {
            if (t.xqName.length > 0) {
              t.formInline.xqName = t.xqName[0]
            }
          }
        } else {
          t.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          })
        }
        Loading.service().close()
      })
    },
    carTypes () {
      const t = this
      const back = new ApiBack()
      back.carTypes().then((res) => {
        if (res.data.code === 0) {
          t.types = res.data.data
        } else {
          t.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    openGateTypes () {
      const t = this
      const back = new ApiBack()
      back.openGateTypes().then((res) => {
        if (res.data.code === 0) {
          t.gateTypes = res.data.data
        } else {
          t.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    // 进场状态
    openGateInStatus () {
      const t = this
      const back = new ApiBack()
      back.openGateInStatus().then((res) => {
        if (res.data.code === 0) {
          t.gateInStatus = res.data.data
        } else {
          t.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    // 出场状态
    openGateOutStatus () {
      const t = this
      const back = new ApiBack()
      back.openGateOutStatus().then((res) => {
        if (res.data.code === 0) {
          t.gateOutStatus = res.data.data
        } else {
          t.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    showImg (e) {
      this.imgSrc = e
    },
    inAndOutDetail () {
      const t = this
      t.tableData = []
      const back = new ApiBack()
      Loading.service()
      let moment = require('moment')
      let inStart = ''
      let inEnd = ''
      if (t.formInline.startTime !== null) {
        inStart = moment(t.formInline.startTime[0]).format('YYYY-MM-DD HH:mm:ss')
        inEnd = moment(t.formInline.startTime[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      let outStart = ''
      let outEnd = ''
      if (t.formInline.endTime !== null) {
        outStart = moment(t.formInline.endTime[0]).format('YYYY-MM-DD HH:mm:ss')
        outEnd = moment(t.formInline.endTime[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      back.inAndOutDetail(t.formInline.xqName, t.formInline.carNum, inStart, t.formInline.serialNO, inEnd, outStart, outEnd, t.pageNum, t.pageSize, t.formInline.inType, t.formInline.outType, t.formInline.carType, (t.formInline.isPay ? 1 : 0)).then((res) => {
        if (res.data.code === 0) {
          t.total = parseInt(res.data.message)
          t.tableData = res.data.data.inAndOutList
          t.totalPay = res.data.data.totalPay
          t.totalPayAct = res.data.data.totalPayAct
        } else {
          t.total = 0
          t.tableData = []
          t.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          })
        }
        Loading.service().close()
      })
    },
    change (e) {
      const t = this
      t.pageNum = e
      t.inAndOutDetail()
    },
    onSearch () {
      this.pageNum = 1
      this.onSubmit('ruleForm')
    },
    onSubmit (formName) {
      const t = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          t.inAndOutDetail()
          t.first = true
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.index {
  padding: 2rem;
  text-align: left;
}
.showImg {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}
.showImg .main {
  width: 100%;
  text-align: center;
}
.showImg img {
  width: 50%;
  margin: 0 auto;
  min-height: 400px;
  background-color: #ffffff;
  display: block;
}
.close {
  font-size: 10rem;
  color: #ffffff;
  transform: rotate(45deg);
}
.money {
  padding: 0.5rem;
  margin-bottom: 1rem;
  font-size: 1.6rem;
  font-weight: 500;
  color: #606266;
}
</style>
<style>
.b-remark {
  color: #606266;
}
.b-remark > span {
  color: #606266;
  font-weight: 400;
  text-overflow: ellipsis;
  width: 100px;
  overflow: hidden;
  display: block;
}
</style>
